import { render, staticRenderFns } from "./VehiclesIcon.vue?vue&type=template&id=32895f58&scoped=true"
var script = {}
import style0 from "./VehiclesIcon.vue?vue&type=style&index=0&id=32895f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32895f58",
  null
  
)

export default component.exports